<template>
    <v-app :dark="luz">
        <v-navigation-drawer fixed clipped app :value="drawer" :temporary="!menuFijo">
            <!--<v-progress-linear indeterminate :active="loading" color="red"></v-progress-linear>-->
            <v-toolbar flat class="transparent">
                <v-list class="pa-0">
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <img :src="(avatar)? avatar : 'img/user-image.png'" alt="avatar" @click="imageSel()"/>
                            <input type="file" style="display: none" ref="file"
                                   @change="imageStore($event.target.files)"/>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ userName }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-toolbar>
            <v-divider></v-divider>
            <v-list dense>
                <v-list-tile @click="" to="/novedades" exact>
                    <v-list-tile-action>
                        <v-icon :color="(notifica)? 'orange': ''"
                                :class="{'animated infinite delay-2s swing':notifica}"
                        >notifications
                        </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            NOVEDADES
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <template v-for="(item, i) in items">
                    <v-list-group v-if="item.children" v-model="item.model" no-action :prepend-icon="item.icon">
                        <v-list-tile slot="activator" @click="">
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="item.subtitle">{{ item.subtitle }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <template v-for="(child, i) in item.children">
                            <v-list-group v-if="child.children" sub-group no-action v-model="child.model">
                                <v-list-tile slot="activator">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ child.title }}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="child.subtitle">{{ child.subtitle }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <template v-for="(c, i) in child.children">
                                    <v-list-tile :to="c.url">
                                        <v-list-tile-title>{{ c.title }}</v-list-tile-title>
                                        <v-list-tile-action v-if="c.icon">
                                            <v-icon>{{ c.icon }}</v-icon>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>
                            </v-list-group>
                            <v-list-tile v-else :to="child.url">
                                <v-list-tile-action v-if="child.icon">
                                    <v-icon>{{ child.icon }}</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ child.title }}</v-list-tile-title>
                                    <v-list-tile-sub-title v-if="child.subtitle">{{ child.subtitle }}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-list-group>
                    <v-list-tile v-else @click="" :to="item.url" exact>
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{ item.title }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
            <v-divider></v-divider>
        </v-navigation-drawer>
        <v-toolbar class="primary" dark app fixed clipped-left dense>
            <v-toolbar-side-icon @click.stop="drawerToggle()"></v-toolbar-side-icon>
            <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
                <v-avatar size="115px" @click.stop="drawerToggle()" tile>
                    <img :src="'./img/iso-gltn-blanco2.svg'" alt="avatar">
                </v-avatar>
                <span v-if="env">{{ env }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn href="https://gestion.gltn.com.ar/totvshelp/spanish/help101.htm" flat icon exact target="_blank">
                <v-icon>help_outline</v-icon>
            </v-btn>
            <v-btn @click.native="setFullscreen()" icon flat>
                <v-icon>{{ (fullscreen)? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
            </v-btn>
            <!--//NOTIFICACIONES////////////////////////////////////////////////////////////////////////////////////////////-->
            <v-menu :close-on-content-click="false" fixed allow-overflow :max-height="500" nudge-bottom="40" left
                    transition="slide-y-transition">
                <v-btn icon slot="activator" :loading="loadingNotif">
                    <v-badge color="red" overlap>
                        <span slot="badge" v-if="notificaciones.length > 0">{{ notificaciones.length }}</span>
                        <v-icon>notifications</v-icon>
                    </v-badge>
                </v-btn>
                <v-list>
                    <v-list-tile v-if="notificaciones.length === 0">
                        <v-list-tile-content>
                            <v-list-tile-title>SIN NOTIFICACIONES</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <template v-for="(item, i) in notificaciones">
                        <v-list-tile @click="notificacionLeida(item.id)">
                            <v-list-tile-avatar :color="(item.data.color)? item.data.color : ''" :size="30">
                                <v-progress-circular v-if="loadingLeida === item.id" indeterminate
                                                     color="white"></v-progress-circular>
                                <v-icon v-else color="white">{{ (item.data.avatar)? item.data.avatar : 'notifications'
                                    }}
                                </v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.data.mensaje }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ item.created_at | tiempo }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                    </template>
                </v-list>
            </v-menu>
            <!--//SETTINGS////////////////////////////////////////////////////////////////////////////////////////////-->
            <v-menu :close-on-content-click="false" fixed allow-overflow :max-height="500" nudge-bottom="40" left
                    transition="slide-y-transition">
                <v-btn icon slot="activator">
                    <v-icon>settings</v-icon>
                </v-btn>
                <v-list>
                    <v-subheader>Opciones de menu</v-subheader>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-switch v-model="menuFijo"></v-switch>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>Fijar</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-subheader>Opciones generales</v-subheader>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-switch :value="luz" @change="luzUpdate" :input-value="luz"></v-switch>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>Luz</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-switch :value="movil" @change="movilUpdate" :input-value="movil"></v-switch>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>Version movil</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-btn icon @click.native="logout()">
                <v-icon class="red--text">fa-sign-out-alt</v-icon>
            </v-btn>
            <v-progress-linear class="pagina-progreso" height="4" indeterminate :active="loadingActive"
                               color="secondary"></v-progress-linear>
        </v-toolbar>
        <v-content>
            <transition name="animate" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
                        mode="out-in">
                <router-view></router-view>
            </transition>
        </v-content>
        <!--///////////////////////////////////  MENSAJES DE ERRORES  ////////////////////////////////////////////////-->
        <v-snackbar @input="msjEstado($event)" :value="msj.mostrar" v-if="!msj.errores" :color="msjColor">
            {{ msj.txt }}
            <v-btn dark flat @click.native="msjEstado(false)" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-dialog @input="msjEstado($event)" :value="msj.mostrar" v-else persistent scrollable max-width="600">
            <v-card>
                <v-card-title dark class="headline red white--text text-xs-center">{{ msj.txt }}</v-card-title>
                <v-card-text>
                    <p v-for="(v,k) in msj.errores">
                        <span v-for="d in v">{{ d }}</span>
                    </p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click.native="msjEstado(false)">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--///////////////////////////////////  LOADING  ////////////////////////////////////////////////-->
        <v-dialog v-model="progresoEstado" persistent width="400">
            <v-card color="primary" dark>
                <v-card-text class="text-xs-center">
                    <div style="width: 100%">
                        <span>{{ progresoTit }}</span>
                        <v-icon style="float:right" @click="progresoHide()">close</v-icon>
                    </div>
                    <v-progress-linear :indeterminate="indeterminate" v-model="progresoPorcent" color="white"
                                       class="mb-0"></v-progress-linear>
                    <div style="width: 100%" class="text-xs-center">{{ progresoMsj }}</div>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-app>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex';
    // import {registrar} from "../plugins/firesbase";
    import mixinNotif from "../mixins/notificaciones";
    import mixinConfig from "../mixins/config";
    import mixinUser from "../mixins/auth/users";
    import moment from 'moment';

    export default {
        name: 'app-layout',
        mixins: [mixinNotif, mixinConfig, mixinUser],
        filters: {
            tiempo(v) {
                return moment(v).fromNow();
            }
        },
        data() {
            return {
                tt: true,
                dbName: window.Laravel.dbName,
                loading: false,
                loadingNotif: false,
                loadingLeida: -1,
                items: [],
                imageBlob: {},
                image: {},
                notificaciones: [],
                menuFijo: true,
                env: Laravel.env,
                notifica: 0,
                fullscreen: false,

            };
        },
        computed: {
            ...mapGetters('config', ['luz', 'movil', 'drawer']),
            ...mapGetters('loading', ['loadingActive']),
            ...mapGetters('auth', ['avatar', 'userName', 'isLoggedIn']),
            ...mapGetters('notif', ['msj']),
            ...mapGetters('progreso', ['progresoEstado', 'indeterminate', 'progresoMsj', 'progresoTit', 'progresoPorcent']),
            msjColor() {
                if (this.msj.tipo === 'error' || this.msj.tipo === 2) {
                    return 'red';
                }
                if (this.msj.tipo === 'ok' || this.msj.tipo === 1 || this.msj.tipo === 'success') {
                    return 'green'
                }
            }
        },
        mounted() {
            this.getArbol();
            // if (this.isLoggedIn) {
            // registrar();
            // this.fcm();
            // }
            this.notificacionesGet();
            this.configGet('notifica', r => {
                this.notifica = r;
            }, err => console.error(err))
            // this.userAvatar(r => {
            //     console.log(r)
            // }, err => console.log(err));
        },
        methods: {
            ...mapActions('config', ['setLuz', 'setMovil', 'drawerToggle']),
            ...mapActions('notif', ['msjSetEstado', 'msjShow']),
            ...mapActions('progreso', ['progresoHide', 'progresoShow']),
            ...mapActions('auth', ['SET_AVATAR']),
            setFullscreen() {
                let el = document.body;
                let isInFullScreen = (document.fullScreenElement && document.fullScreenElement !== null) || (document.mozFullScreen || document.webkitIsFullScreen);
                if (isInFullScreen) {
                    let requestMethod = document.webkitExitFullscreen || document.exitFullscreen;
                    if (requestMethod) { // cancel full screen.
                        requestMethod.call(document);
                        this.fullscreen = false;
                    }
                } else {
                    let requestMethod = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen;
                    if (requestMethod) {
                        requestMethod.call(el);
                        this.fullscreen = true;
                    }
                }

            },
            msjEstado(valor) {
                this.msjSetEstado(valor);
            },
            getArbol() {
                this.loading = true;
                this.$http.post('menu/arbol')
                    .then(r => {
                        this.items = r.data;
                        this.loading = false;
                    })
                    .catch(err => {
                        console.log(err)
                        this.loading = false;
                    })
            },
            luzUpdate() {
                this.setLuz(!this.luz);
            },
            movilUpdate() {
                this.setMovil(!this.movil);
            },
            logout() {
                this.$http.post('logout')
                    .then(r => {
                        this.$ls.remove('token');
                        this.$store.dispatch('auth/unsetAuthUser');
                        this.$router.push('/login');
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            imageSel() {
                this.$refs.file.click();
            },
            imageStore(fileList) {
                if (!fileList.length) return;
                let reader = new FileReader();
                let self = this;
                reader.onload = (e) => {
                    self.image = e.target.result;
                };
                reader.readAsDataURL(fileList[0]);
                let rd = new FileReader();
                rd.onload = (e) => {
                    this.imageBlob = e.target.result;
                    this.imageProcess();
                };
                rd.readAsArrayBuffer(fileList[0])
            },
            imageProcess() {
                let fd = new FormData();
                let imgBlob = new Blob([this.imageBlob], {type: 'image/jpeg'});
                fd.append('picture', imgBlob);
                this.imageUpload(fd)
            },
            imageUpload(fd) {
                this.$http.post('users/avatar-update', fd)
                    .then(r => {
                        this.SET_AVATAR(r.data);
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            fcm() {
                this.$msg.onMessage((p) => {
                    this.notificacionesGet();
                    let msj = '<b>' + p.notification.title + '</b><br>' + p.notification.body;
                    this.$noty.info(msj, {
                        layout: 'bottomRight',
                        theme: 'relax',
                        sounds: {
                            sources: [
                                // window.Laravel.urlBase + '/sounds/terror.mp3',
                                window.Laravel.urlBase + '/sounds/best_iphone_x.mp3',
                                // window.Laravel.urlBase + '/sounds/fiufiufiu.mp3',
                                // window.Laravel.urlBase + '/sounds/go_f_yourself.mp3',
                                // window.Laravel.urlBase + '/sounds/trompeta_militar.mp3',
                            ],
                            conditions: ['docVisible', 'docHidden']
                        },
                        docTitle: {
                            conditions: ['docVisible', 'docHidden']
                        }
                    })
                });
            },
            notificacionesGet() {
                let self = this;
                self.loadingNotif = true;
                self.notifUsuarioSinLeer(r => {
                    self.notificaciones = (!r) ? [] : r;
                    self.loadingNotif = false;
                }, err => {
                    self.loadingNotif = false;
                })
            },
            notificacionLeida(id) {
                this.loadingLeida = id;
                this.notifLeida({id: id}, r => {
                    this.loadingLeida = -1;
                    this.notificacionesGet();
                }, err => {
                    this.loadingLeida = -1;
                })
            }
        }
    };
</script>
<style scoped>
    .pagina-progreso {
        position: absolute !important;
        margin: 0;
        bottom: 0;
        left: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/layouts/app.vue